// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { StockManagementQueries } from '../../../../types/server/modules/stockManagement/queries';

export type * from '../../../../types/server/modules/stockManagement/queries';

export const createQueries = ( requests: Requests ): StockManagementQueries => ({
  StockManagementWarehousesById: ( id, query, headers ) => { 
          return requests.get( `/stock-management/warehouses/${id}`, query, headers ); 
        },
  StockManagementWarehouses: ( params?, headers? ) => {
        return requests.get( `/stock-management/warehouses/:id?`, params, headers );
      },
  StockManagementWarehouseConfigById: ( id, query, headers ) => { 
          return requests.get( `/stock-management/warehouse-config/${id}`, query, headers ); 
        },
  StockManagementWarehouseConfig: ( params?, headers? ) => {
        return requests.get( `/stock-management/warehouse-config/:id?`, params, headers );
      },
  StockAnalyticsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/stock-analytics-readmodel/${id}`, query, headers ); 
        },
  StockAnalyticsReadmodel: ( params?, headers? ) => {
        return requests.get( `/stock-analytics-readmodel/:id?`, params, headers );
      },
  StockManagementShortfallsById: ( id, query, headers ) => { 
          return requests.get( `/stock-management/shortfalls/${id}`, query, headers ); 
        },
  StockManagementShortfalls: ( params?, headers? ) => {
        return requests.get( `/stock-management/shortfalls/:id?`, params, headers );
      },
  StockManagementMovementsByOrderById: ( id, query, headers ) => { 
          return requests.get( `/stock-management/movements-by-order/${id}`, query, headers ); 
        },
  StockManagementMovementsByOrder: ( params?, headers? ) => {
        return requests.get( `/stock-management/movements-by-order/:id?`, params, headers );
      }
});
